import { Group, Text } from '@mantine/core'
import { IconCircleFilled } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { MemberSummary } from './deploymentTreeHelpers'

const COUNTERS: { key: keyof Omit<MemberSummary, 'total'>; color: string }[] = [
  { key: 'running', color: 'var(--mantine-color-green-6)' },
  { key: 'connecting', color: 'var(--mantine-color-yellow-6)' },
  { key: 'failed', color: 'var(--mantine-color-red-6)' },
  { key: 'stopped', color: 'var(--mantine-color-gray-7)' },
  { key: 'other', color: 'var(--mantine-color-gray-5)' }
]

type MemberStatusCountProps = {
  summary: MemberSummary
}

export const MemberStatusCount = ({ summary }: MemberStatusCountProps) => {
  return (
    <Group gap="xs">
      {COUNTERS.filter(({ key }) => summary[key] > 0).map(({ key, color }) => (
        <Group key={key} gap={4} wrap="nowrap">
          <IconCircleFilled size={9} color={color} />

          <Text size="xs" style={{ whiteSpace: 'nowrap' }}>
            <FormattedMessage
              id={`deployments.list.member.${key}`}
              values={{ count: summary[key] }}
            />
          </Text>
        </Group>
      ))}
    </Group>
  )
}
